import React from 'react';
import { marketplaceIconMap, marketplaceBrandColors } from '../shared/icons';

const MarketplaceLinks = ({ theme, marketplaces }) => {
  const validLinks = Object.entries(marketplaces).filter(([, url]) => url?.trim());
  if (!validLinks.length) return null;

  return (
    <section style={{
      backgroundColor: theme.colors.background,
      borderRadius: theme.borderRadius.lg,
      boxShadow: theme.shadows.md,
      padding: '40px',
      marginBottom: '40px',
      textAlign: 'center'
    }}>
      <h2 style={{
        fontFamily: theme.fonts.heading, color: theme.colors.heading,
        fontSize: '2rem', margin: '0 0 30px 0'
      }}>
        Shop With Us
      </h2>
      <div style={{ display: 'flex', gap: '15px', justifyContent: 'center', flexWrap: 'wrap' }}>
        {validLinks.map(([platform, url]) => {
          const MarketplaceIcon = marketplaceIconMap[platform.toLowerCase()];
          const brandColor = marketplaceBrandColors[platform.toLowerCase()];
          return (
            <a
              key={platform}
              data-field={platform}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              title={`Shop on ${platform.charAt(0).toUpperCase() + platform.slice(1)}`}
              style={{
                backgroundColor: brandColor || theme.colors.primary,
                color: '#ffffff', width: '50px', height: '50px', borderRadius: '50%',
                textDecoration: 'none', boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                transition: 'all 0.2s ease', display: 'flex',
                alignItems: 'center', justifyContent: 'center'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-3px) scale(1.1)';
                e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.25)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = 'translateY(0) scale(1)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
              }}
            >
              {MarketplaceIcon && <MarketplaceIcon size={24} />}
            </a>
          );
        })}
      </div>
    </section>
  );
};

export default MarketplaceLinks;
